<ion-header>
  <app-upload-control [uploadItems]="uploadItems"></app-upload-control>
</ion-header>

<ion-content>
  <ion-list>
    <app-upload-item *ngFor="let uploadItem of uploadItems" [uploadItem]="uploadItem"></app-upload-item>
  </ion-list>
</ion-content>
